/** A labeled row of examples inside a gallery section. */
const GalleryExample = ({ label, stacked = false, children }) => {
  return (
    <div className="gallery-example">
      <p className="gallery-example__label">{label}</p>
      <div className={stacked ? 'gallery-example__items gallery-example__items--stacked' : 'gallery-example__items'}>{children}</div>
    </div>
  );
};

export default GalleryExample;
